import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

export const ToastPedido = () => {
    const [notification, setNotification] = useState({ title: '', body: '' });

    useEffect(() => {
        if (notification.title) {
            notify();
        }
    }, [notification]);

    const notify = () => {
        toast.info(
            <div>
                {notification.title}
                <br />
                {notification.body}
            </div>,
            {
                position: 'top-center',
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            }
        );
    };

    return (
        <ToastContainer
            position="top-center"
            autoClose={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            style={{ fontSize: 'small' }}
        />
    );
};
